import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import axios from 'axios';
import WorkshopSelection from './WorkshopSelection';
import { calcWorkshopFee, formatIdr, findWorkshopLabel } from '../utils/workshopPricing';

const Register = () => {
    const [events, setEvents] = useState([]);
    const [audienceCategories, setAudienceCategories] = useState([]);
    const [hotels, setHotels] = useState([]);
    const [accomodationHotels, setAccomodationHotels] = useState([]);
    const [typeKamarOptions, setTypeKamarOptions] = useState([]);
    const [accomodations, setAccomodations] = useState([]);
    const [nextValue, setNextValue] = useState(null);
    const apiUrl = process.env.REACT_APP_API_ENDPOINT;
    const [eventPrices, setEventPrices] = useState([]);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [categoryEventOptions, setCategoryEventOptions] = useState([]);
    const [categoryDetail, setCategoryDetail] = useState(null);
    const [categoryDetails, setCategoryDetails] = useState([]);
    const [workshopCatalog, setWorkshopCatalog] = useState({ sabtu: [], minggu: [], prices: { one: 1199000, two: 1999000 } });


    useEffect(() => {
        api.get('/public/events')
            .then((res) => {
                setEvents(res.data);
            })
            .catch((err) => {
                console.error("Failed to fetch events:", err);
            });
    }, []);


    // Saat event dipilih, ambil EventPrice
    const handleEventChange = async (e) => {
        const eventId = e.target.value;
        setForm(prev => ({ ...prev, event: eventId, workshopSabtuId: "", workshopMingguId: "" }));
        if (eventId) {
            const res = await axios.get(`${apiUrl}/api/public/audience-category-price/by-event?eventId=${eventId}`);
            setEventPrices(res.data);
        } else {
            setEventPrices([]);
        }
    };


    useEffect(() => {
        api.get('/public/hotel?page=0&size=100')
            .then(res => {
                console.log('Hotels data:', res.data);
                setHotels(res.data.content);
            });
    }, []);

    // useEffect(() => {
    //     if (events && events.id) {
    //         api.get(`/public/audience-category/by-event`, {
    //             params: {
    //                 eventId: events.id,
    //                 page: 0,
    //                 size: 100
    //             }
    //         }).then(res => setAudienceCategories(res.data.content))
    //             .catch(err => console.error('Error fetching audience categories:', err));
    //     }
    // }, [events.id]);


    // Pastikan state form diinisialisasi dengan benar
    const [form, setForm] = useState({
        event: "", // atau null
        eventPrice: "", // atau null
        hotelId: "", // atau null
        nama: "",
        namaLengkapGelar: "",
        nik: "",
        audienceCategory: "",
        audienceCategoryDetail: "",
        asalInstitusi: "",
        categoryEvent: "",
        workshopSabtuId: "",
        workshopMingguId: "",
        hp: "",
        email: "",
        password: "",
        confirmPassword: "",
    });
    const [error, setError] = useState("");
    const [emailExists, setEmailExists] = useState(false);
    const [checkingEmail, setCheckingEmail] = useState(false);
    const navigate = useNavigate();

    const handleChange = async (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
        setError(""); // reset error saat input berubah

        if (name === "audienceCategory" && value) {
            // Ambil semua detail untuk kategori peserta ini
            try {
                const res = await axios.get(`${apiUrl}/api/public/audience-category-detail/by-category/${value}`);
                const details = Array.isArray(res.data) ? res.data : [res.data].filter(Boolean);
                setCategoryDetails(details);
                setForm((prev) => ({
                    ...prev,
                    audienceCategoryDetail: details.length === 1 ? String(details[0].id) : "",
                }));
            } catch {
                setCategoryDetails([]);
                setForm((prev) => ({ ...prev, audienceCategoryDetail: "" }));
            }
        }

        if (name === "email") {
            setCheckingEmail(true);
            setEmailExists(false);
            if (value) {
                try {
                    const res = await axios.get(`${apiUrl}/api/auth/checkEmail/${encodeURIComponent(value)}`);
                    setEmailExists(res.data === true);
                } catch {
                    setEmailExists(false);
                }
            }
            setCheckingEmail(false);
        }
    };

    useEffect(() => {
    const fetchAccomodationHotels = async () => {
        if (form.event && !isNaN(form.event)) {
            try {
                const res = await api.get(`/public/accomodation/get-event`, {
                    params: { eventId: form.event }
                });
                console.log('Accommodation data:', res.data);
                if (Array.isArray(res.data)) {
                    setAccomodationHotels(res.data);
                } else {
                    setAccomodationHotels([]);
                }
            } catch (error) {
                console.error("Gagal mengambil data hotel dari akomodasi:", error);
                setAccomodationHotels([]);
            }
        }
    };

    const fetchAudienceCategory = async () => {
        if (form.event && !isNaN(form.event)) {
            try {
                const res = await api.get(`/public/audience-category/by-event`, {
                    params: { eventId: form.event, page: 0, size: 100 }
                });
                console.log('Audience category data:', res.data);
                if (res.data && Array.isArray(res.data.content)) {
                    setAudienceCategories(res.data.content);
                } else {
                    setAudienceCategories([]);
                }
            } catch (error) {
                console.error("Gagal mengambil data Audience Category:", error);
                setAudienceCategories([]);
            }
        }
    };

    fetchAccomodationHotels();
    fetchAudienceCategory(); // <- PANGGIL DI SINI

}, [form.event]);


    const handleHotelChange = async (e) => {
        const hotelId = e.target.value;
        setForm(prev => ({ ...prev, hotel: hotelId, typeKamar: "", hargaKamar: "", keterangan: "" }));

        if (hotelId) {
            const res = await api.get(`${apiUrl}/api/public/get-hotel?hotelId=${hotelId}`);
            setAccomodations(res.data);

            // Ambil type kamar unik
            const typeKamarList = res.data
                .map(acc => acc.typeKamar)
                .filter((val, idx, arr) => val && arr.indexOf(val) === idx);
            setTypeKamarOptions(typeKamarList);
        } else {
            setAccomodations([]);
            setTypeKamarOptions([]);
        }
    };

    const handleTypeKamarChange = (e) => {
        const typeKamar = e.target.value;
        setForm(prev => ({ ...prev, typeKamar }));

        // Cari data accomodation yang sesuai type kamar
        const selected = accomodations.find(acc => acc.typeKamar === typeKamar);
        if (selected) {
            setForm(prev => ({
                ...prev,
                hargaKamar: selected.hargaKamar,
                keterangan: selected.keterangan
            }));
        } else {
            setForm(prev => ({
                ...prev,
                hargaKamar: "",
                keterangan: ""
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validasi password
        if (form.password !== form.confirmPassword) {
            setError("Password dan Konfirmasi Password harus sama!");
            return;
        }

        // Tampilkan modal konfirmasi
        setShowConfirmModal(true);
    };

    // const handleConfirmSubmit = async () => {
    //     try {
    //         let sequence = 0;
    //         const a = await axios.get(`${apiUrl}/api/public/sequence`);
    //         sequence = a.data.nextValue;

    //         const today = new Date();
    //         const dd = String(today.getDate()).padStart(2, '0');
    //         const mm = today.getMonth() + 1; // 1-based
    //         const yyyy = today.getFullYear();
    //         // Fungsi konversi angka ke angka Romawi
    //         function toRoman(num) {
    //             const roman = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];
    //             return roman[num - 1] || "";
    //         }
    //         const romanMonth = toRoman(mm);
    //         const paddedSequence = String(sequence).padStart(3, '0');
    //         const nomorRegistrasi = `${paddedSequence}/CIU-IDAIBanten/${romanMonth}/${yyyy}`;

    //         await api.post('/public/peserta', {

    //             nomorRegistrasi,
    //             eventId: form.event,
    //             eventPriceId: form.eventPrice, // pastikan ini sesuai dengan name di select
    //             nama: form.nama,
    //             namaLengkapGelar: form.namaLengkapGelar,
    //             nik: form.nik,
    //             audienceCategoryId: form.audienceCategory,
    //             audienceCategoryDetailId: form.audienceCategoryDetail,
    //             asalInstitusi: form.asalInstitusi,
    //             categoryEvent: form.categoryEvent,
    //             akomodasiHotel: form.akomodasiHotel === "ya",
    //             hotelId: form.akomodasiHotel === "ya" ? form.hotel : null,
    //             typeKamar: form.akomodasiHotel === "ya" ? form.typeKamar : null,
    //             hargaKamar: form.akomodasiHotel === "ya" ? form.hargaKamar : null,
    //             keterangan: form.akomodasiHotel === "ya" ? form.keterangan : null,
    //             hp: form.hp,
    //             email: form.email,
    //             password: form.password,
    //             sequence,
    //             awalInap: form.awalInap,
    //             akhirInap: form.akhirInap,
    //         });
    //         alert(`Pendaftaran berhasil!\nNomor Registrasi Anda: ${nomorRegistrasi}\nCek email Anda untuk detail pendaftaran.`);
    //         navigate('/');
    //     } catch (err) {
    //         alert('Pendaftaran gagal!');
    //         console.error(err);
    //     }
    // };

    const handleConfirmSubmit = async () => {
        try {
            // Get sequence and event code from backend
            const response = await axios.get(`${apiUrl}/api/public/sequence-with-event-code/${form.event}`);
            const { nextValue: sequence, nomorRegistrasi } = response.data;
    
            await api.post('/public/peserta', {
                nomorRegistrasi,
                eventId: form.event,
                eventPriceId: form.eventPrice,
                nama: form.nama,
                namaLengkapGelar: form.namaLengkapGelar,
                nik: form.nik,
                audienceCategoryId: form.audienceCategory,
                audienceCategoryDetailId: form.audienceCategoryDetail,
                asalInstitusi: form.asalInstitusi,
                categoryEvent: form.categoryEvent,
                workshopSabtuId: form.workshopSabtuId ? Number(form.workshopSabtuId) : null,
                workshopMingguId: form.workshopMingguId ? Number(form.workshopMingguId) : null,
                hp: form.hp,
                email: form.email,
                password: form.password,
                sequence,
            });
            alert(`Pendaftaran berhasil!\nNomor Registrasi Anda: ${nomorRegistrasi}\nCek email Anda untuk detail pendaftaran.`);
            navigate('/');
        } catch (err) {
            alert('Pendaftaran gagal!');
            console.error(err);
        }
    };

    
    return (
        <>
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <h3 className="card-title mb-4 text-center">Register</h3>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Event</label>
                                        <select
                                            className="form-select"
                                            name="event"
                                            value={form.event || ""}
                                            onChange={handleEventChange}
                                            required
                                        >
                                            <option value="">Pilih Event</option>
                                            {events.map((event) => (
                                                <option key={event.id} value={event.id}>
                                                    {event.eventCode} - {event.title}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Nama Lengkap Sesuai KTP</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="nama"
                                            value={form.nama}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Nama Lengkap dengan Gelar</label>
                                        <input type="text" className="form-control" name="namaLengkapGelar" value={form.namaLengkapGelar} onChange={handleChange} required />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">NIK</label>
                                        <input type="text" className="form-control" name="nik" value={form.nik} onChange={handleChange} required />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">No HP</label>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            name="hp"
                                            value={form.hp}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Alamat Email Sesuai Akun Satu Sehat SDMK (LMS)</label>
                                        <input
                                            type="email"
                                            className={`form-control ${emailExists ? 'is-invalid' : ''}`}
                                            name="email"
                                            value={form.email}
                                            onChange={handleChange}
                                            required
                                        />
                                        {checkingEmail && <div className="form-text text-info">Memeriksa email...</div>}
                                        {emailExists && (
                                            <div className="invalid-feedback">
                                                Email sudah terdaftar, silakan gunakan email lain.
                                            </div>
                                        )}
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Kategori Peserta</label>
                                        <select
                                            className="form-select"
                                            name="audienceCategory"
                                            value={form.audienceCategory}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Pilih Kategori Peserta</option>
                                            {audienceCategories.map((cat) => (
                                                <option key={cat.id} value={cat.id}>
                                                    {cat.namaCategory}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {categoryDetails.length > 0 && (
                                        <div className="mb-3">
                                            <label className="form-label">Biaya Simposium</label>
                                            <select
                                                className="form-select"
                                                name="audienceCategoryDetail"
                                                value={form.audienceCategoryDetail || ""}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value="">Pilih Detail</option>
                                                {categoryDetails.map((detail) => (
                                                    <option key={detail.id} value={detail.id}>
                                                        {detail.categoryEvent}
                                                    </option>
                                                ))}
                                            </select>
                                            {form.audienceCategoryDetail && (() => {
                                                const selectedDetail = categoryDetails.find(d => String(d.id) === String(form.audienceCategoryDetail));
                                                return selectedDetail ? (
                                                    <>
                                                        <div className="form-text mt-2">
                                                            Harga: <strong>{Number(selectedDetail.biayaEvent).toLocaleString("id-ID", { style: "currency", currency: "IDR" })}</strong>
                                                        </div>
                                                        {/* <div className="form-text text-secondary">
                                                            Format ribuan: <strong>{Number(selectedDetail.biayaEvent).toLocaleString("id-ID")}</strong>
                                                        </div> */}
                                                    </>
                                                ) : null;
                                            })()}
                                        </div>
                                    )}
                                    <div className="mb-3">
                                        <label className="form-label">Asal Institusi</label>
                                        <input type="text" className="form-control" name="asalInstitusi" value={form.asalInstitusi} onChange={handleChange} required />
                                    </div>
                                    

                                    {form.event && (
                                        <WorkshopSelection
                                            eventId={form.event}
                                            form={form}
                                            onChange={handleChange}
                                            onWorkshopsLoaded={setWorkshopCatalog}
                                            symposiumFee={
                                                categoryDetails.find(
                                                    (d) => String(d.id) === String(form.audienceCategoryDetail)
                                                )?.biayaEvent || 0
                                            }
                                        />
                                    )}

                                    {false && form.akomodasiHotel === "ya" && (
                                        <>
                                            <div className="mb-3">
                                                <label className="form-label">Nama Hotel</label>
                                                <select
                                                    className="form-select"
                                                    name="hotel"
                                                    value={form.hotel}
                                                    onChange={handleHotelChange}
                                                    required
                                                >
                                                    <option value="">Pilih Hotel</option>
                                                    {accomodationHotels.map((hotel) => (
                                                        <option key={hotel.id} value={hotel.id}>
                                                            {hotel.namaHotel}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Awal Inap */}
                                            <div className="mb-3">
                                                <label className="form-label">Tanggal Check-In</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="awalInap"
                                                    value={form.awalInap || ""}
                                                    onChange={handleChange}
                                                    required={form.akomodasiHotel === "ya"}
                                                />
                                            </div>

                                            {/* Akhir Inap */}
                                            <div className="mb-3">
                                                <label className="form-label">Tanggal Check-Out</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="akhirInap"
                                                    value={form.akhirInap || ""}
                                                    onChange={handleChange}
                                                    required={form.akomodasiHotel === "ya"}
                                                />
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">Tipe Kamar</label>
                                                <select
                                                    className="form-select"
                                                    name="typeKamar"
                                                    value={form.typeKamar}
                                                    onChange={handleTypeKamarChange}
                                                    required
                                                >
                                                    <option value="">Pilih Type Kamar</option>
                                                    {typeKamarOptions.map((type, idx) => (
                                                        <option key={idx} value={type}>
                                                            {type}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="mb-3 row align-items-center">
                                                <label className="col-sm-4 col-form-label">Harga Kamar</label>
                                                <div className="col-sm-8">
                                                    <div className="form-control-plaintext text-end">
                                                        {form.hargaKamar
                                                            ? "Rp " + Number(form.hargaKamar).toLocaleString("id-ID")
                                                            : "-"}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mb-3 row align-items-center">
                                                <label className="col-sm-4 col-form-label">Keterangan</label>
                                                <div className="col-sm-8">
                                                    <div className="form-control-plaintext text-end">
                                                        {form.keterangan || "-"}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    <div className="mb-3">
                                        <label className="form-label">Password</label>
                                        <div className="input-group">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className="form-control"
                                                name="password"
                                                value={form.password}
                                                onChange={handleChange}
                                                required
                                            />
                                            <button
                                                className="btn btn-outline-secondary"
                                                type="button"
                                                onClick={() => setShowPassword(!showPassword)}
                                            >
                                                <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Konfirmasi Password</label>
                                        <div className="input-group">
                                            <input
                                                type={showConfirmPassword ? "text" : "password"}
                                                className="form-control"
                                                name="confirmPassword"
                                                value={form.confirmPassword}
                                                onChange={handleChange}
                                                required
                                            />
                                            <button
                                                className="btn btn-outline-secondary"
                                                type="button"
                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            >
                                                <i className={`bi ${showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                                            </button>
                                        </div>
                                    </div>
                                    {error && <div className="alert alert-danger">{error}</div>}

                                    <button type="submit" className="btn btn-primary w-100" disabled={emailExists}>Register</button>
                                    <div className="text-center mt-3">
                                        <span>Sudah punya akun? </span>
                                        <a href="/">Login</a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Confirmation Modal */}
            {showConfirmModal && (
                <div className="modal modal-blur show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Konfirmasi Registrasi</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowConfirmModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>Mohon periksa kembali data registrasi Anda:</p>
                                <div className="table-responsive">
                                    <table className="table table-sm">
                                        <tbody>
                                            <tr>
                                                <td width="30%"><strong>Nama</strong></td>
                                                <td>{form.nama}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Email</strong></td>
                                                <td>{form.email}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Event</strong></td>
                                                <td>
                                                    {events.find(e => e.id === Number(form.event))?.title || '-'}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><strong>Kategori</strong></td>
                                                <td>{audienceCategories.find(cat => cat.id === Number(form.audienceCategory))?.namaCategory || '-'}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Harga Event</strong></td>
                                                <td>
                                                    {form.audienceCategoryDetail && (() => {
                                                        const selectedDetail = categoryDetails.find(d => String(d.id) === String(form.audienceCategoryDetail));
                                                        return selectedDetail && selectedDetail.biayaEvent
                                                            ? Number(selectedDetail.biayaEvent).toLocaleString("id-ID", { style: "currency", currency: "IDR" })
                                                            : '-';
                                                    })()}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><strong>Workshop Sabtu</strong></td>
                                                <td>{findWorkshopLabel(workshopCatalog, form.workshopSabtuId)}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Workshop Minggu</strong></td>
                                                <td>{findWorkshopLabel(workshopCatalog, form.workshopMingguId)}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Biaya Workshop</strong></td>
                                                <td>{formatIdr(calcWorkshopFee(form.workshopSabtuId, form.workshopMingguId, workshopCatalog.prices))}</td>
                                            </tr>
                                            <tr className="table-primary">
                                                <td><strong>Total Biaya</strong></td>
                                                <td>
                                                    {(() => {
                                                        const selectedDetail = categoryDetails.find(d => String(d.id) === String(form.audienceCategoryDetail));
                                                        const symposium = selectedDetail?.biayaEvent ? Number(selectedDetail.biayaEvent) : 0;
                                                        const workshop = calcWorkshopFee(form.workshopSabtuId, form.workshopMingguId, workshopCatalog.prices);
                                                        return formatIdr(symposium + workshop);
                                                    })()}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="alert alert-info mt-3">
                                    <i className="bi bi-info-circle me-2"></i>
                                    Pastikan data yang Anda masukkan sudah benar. Email akan digunakan untuk login dan komunikasi selanjutnya.
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-link link-secondary"
                                    onClick={() => setShowConfirmModal(false)}
                                >
                                    Batalkan
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary ms-auto"
                                    onClick={handleConfirmSubmit}
                                >
                                    <i className="bi bi-check2 me-2"></i>
                                    Ya, Lanjutkan Registrasi
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Register;